var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_vm._v(" "),_c('confirm-modal',{attrs:{"show-confirm":_vm.showConfirm,"confirm-message":_vm.confirmMessage},on:{"ok":_vm.ok,"cancel":_vm.cancel}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }